import css from '../../../utils/css';
import themeExtension from './theme-extension';
import patches from './patches';

const mapCssVars = css`
  :host {
    /* Adapter affected */
    --ogm-text-body: var(--widget-text-color);
    --ogm-text-main: var(--widget-text-color);
    --ogm-bg-grey-2: #f7f7f7;
    --ogm-disabled-grey: #b2b2b2;
    --ogm-border-color-1: #e5e5e5;

    --oc-primary-blue: var(--widget-text-color);
    --oc-text-body: var(--widget-text-color);
    --oc-text-white: white;

    --ogm-odds-grid-see-all-odds-color: var(--widget-mobile-seeall-color);

    --oc-text-subtext: var(--widget-subtext-color);
    --ogm-grid-main-bg-color: var(--widget-background-color);
    --ogm-grid-main-border-color: var(--widget-border-color);
    --oc-border: var(--widget-divider-color);
    --oc-line-secondary: var(--widget-divider-color);

    --ogm-title-bg-color-2: var(--widget-header-bg-color);
    --ogm-title-color-1: var(--widget-header-text-color);
    --oc-bg-grey-light: var(--widget-header-odds-bg-color);
    --oc-box-shadow: var(--widget-header-odds-shadow);

    --ogm-grid-best-odds-primary-color: var(
      --widget-grid-best-odds-border-color
    );
    --ogm-grid-best-odds-secondary-color: var(--widget-grid-best-odds-bg-color);
    --ogm-grid-best-odds-text-color: var(--widget-grid-best-odds-text-color);

    --ogm-grid-odds-tooltip-bg-color: var(--widget-grid-ribbon-bg-color);
    --oc-primary-white: var(--widget-grid-ribbon-color);

    --ogm-grid-compare-bg-color: var(--widget-grid-compare-active-bg-color);
    --ogm-grid-compare-color: var(
      --widget-grid-compare-color,
      var(--widget-text-color)
    );

    --ogm-active-tab-bg-color: var(--widget-text-color);
    --ogm-active-tab-color: var(--widget-background-color);

    --ogm-grid-offer-bg-color: var(--widget-text-color);
    --ogm-grid-offer-color: var(--widget-background-color);

    --oc-odds-drifting-bg: var(
      --widget-odds-drifting-bg,
      rgba(255, 175, 186, 0.4)
    );
    --oc-odds-drifting-rgb: var(--widget-odds-drifting-rgb, 255, 175, 186);
    --oc-odds-drifting: var(--widget-odds-drifting, #ffafba);

    --oc-odds-shortening-bg: var(
      --widget-odds-shortening-bg,
      rgba(140, 204, 242, 0.4)
    );
    --oc-odds-shortening-rgb: var(--widget-odds-shortening-rgb, 140, 204, 242);
    --oc-odds-shortening: var(--widget-odds-shortening, #8cccf2);

    /* odds-grid-external 15.0.0+'s best-odds module price button reads these
     * cxy tokens instead of --oc-odds-drifting-bg/-shortening-bg; without a
     * bridge it falls back to the same oddschecker colours on every theme. */
    --cxy-color-surface-betting-drifting: var(--oc-odds-drifting-bg);
    --cxy-color-surface-betting-shortening: var(--oc-odds-shortening-bg);
    /* Same component's hover background; fallback restores the old
     * hardcoded #66f1b8 hover for local themes. */
    --cxy-color-background-interactive-base-hover: var(
      --widget-cta-background-color,
      #66f1b8
    );
    /* Same component's text colour (and the offers-bar tooltip); old
     * equivalent was --oc-text-body. */
    --cxy-color-text-neutral-bold: var(--oc-text-body);

    /* not found yet */
    --ogm-background-body: limegreen;
    --ogm-grid-selected-cell-bg-color: transparent; /* probably not used because no bet slip */
    --ogm-grid-selected-cell-text-color: var(--oc-text-white);

    /* non-color setup */

    --ogm-font-family-1: var(--widget-font-family);
    --ogm-font-family-2: var(--widget-font-family);

    --ogm-grid-bookmaker-cell-border-radius-desktop: 2px;
    --ogm-grid-bookmaker-cell-border-radius-mobile: 2px;
    --ogm-grid-bookmaker-cell-height-desktop: 99px;
    --ogm-grid-bookmaker-cell-scale-desktop: 1.7;
    --ogm-grid-bookmaker-cell-width-desktop: var(
      --widget-grid-column-width,
      54px
    );

    --ogm-grid-cell-gap: var(--widget-grid-cell-gap, 1px);
    --ogm-grid-cell-height-desktop: 44px;
    --ogm-grid-cell-width-desktop: var(--widget-grid-cell-width, 44px);

    --ogm-grid-column-height: 54px;
    --ogm-grid-column-width: var(--widget-grid-column-width, 54px);

    --ogm-grid-market-expander-margin: 0;
    --ogm-grid-sticky-marketname-padding-bottom: 18px;

    --ogm-max-width: 1440px;
    --cxy-z-index-above-ad: 10;
  }
`;

export default `${mapCssVars} ${themeExtension} ${patches}`;
